<template>
  <div>
    <div class="row">
      <div class="column small-12">
        <p class="mbm">
          Las siguientes opciones te ayudarán a integrar tu portal de clientes a tu sitio web:
        </p>
        <label for="project-name">
          <strong class="text-black">Texto de la marca blanca</strong>
        </label>
        <span>Selecciona el proyecto que deseas integrar en tu página web</span>
        <select id="project-name" v-model="briefId" name="project-name">
          <option
            v-for="(brief, index) in briefs"
            :key="index"
            :value="brief.briefId"
          >
            {{ brief.briefName }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="column small-12 large-6">
        <label for="frame-height">
          <strong class="text-black">Altura de marco (pixeles)</strong>
        </label>
        <span>La altura del marco (600 pixeles recomendados)</span>
        <input id="frame-height" type="number" value="600" />
      </div>
      <div class="column small-12 large-6">
        <label for="frame-width">
          <strong class="text-black">Ancho de marco (pixeles)</strong>
        </label>
        <span>El ancho del marco (700 pixeles recomendados)</span>
        <input id="frame-width" type="number" value="700" />
      </div>
    </div>
    <div class="row">
      <div class="column small-12">
        <strong class="text-black">Código HTML generado</strong>
        <p>
          Copia y pega el siguiente código en tu sitio web para mostrar el Portal de Cliente en un marco.:
        </p>
        <p v-if="frameMarkup">
          <code>{{ frameMarkup }}</code>
        </p>
      </div>
    </div>
    <div class="row align-center">
      <div class="column small-12">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mbm" />
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="button primary full-width mbn"
          @click="onClickGenerateFrameCode"
        >
          Generar frame code
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    briefs: {
      type: Array,
      default: () => [],
    },
    getIframeCodeApi: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      frameHeight: 600,
      frameWidth: 700,
      briefId: 0,
      frameMarkup: null,
    };
  },
  mounted() {
    this.briefId =
      this.briefs.length > 0 ? this.briefs[0]?.briefId : this.briefId;
  },
  methods: {
    async onClickGenerateFrameCode() {
      try {
        const res = await axios.post(this.getIframeCodeApi, {
          Height: this.frameHeight,
          Width: this.frameWidth,
          BriefId: this.briefId,
        });

        if (res && res.status === 200) {
          this.frameMarkup = res.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
